{
  "createUser": {
    "title": "Creación del usuario"
  },
  "editUser": {
    "title": "Modificar un usuario"
  },
  "selectUserProfileEdit": {
    "title": "Asociar a un perfil"
  },
  "userGroups": {
    "title": "Asociar los grupos"
  }
}
